import Repository from './Repository';
const resource = '';

export default {
  async subscribeEmail(email, province, schoolType, schoolName, schoolId) {

    let url = `${resource}/create_notify_me`;
    let bodyFormData = new FormData();
    bodyFormData.set('email', email);
    bodyFormData.set('province', province);
    bodyFormData.set('schoolType', schoolType);
    bodyFormData.set('schoolName', schoolName);
    bodyFormData.set('schoolId', schoolId);
    await Repository({
      method: 'post',
      url: url,
      data: bodyFormData,
    })
      .then(function (response) {
        return response.statusText === 'OK';
      })
      .catch(function (response) {
        //handle error
        console.log(response);
        return false;
      });
  }
}
